import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder,FormGroup,Validators,FormArray,FormControl } from '@angular/forms';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { AddFieldsVM } from 'src/app/viewModels/core/add-fields-vm';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from '../services/settingService/setting.service';
import { CommonService } from 'src/app/middleware/common/common.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { CCCName } from '../services/settingService/setting.enum';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-edit-field',
  templateUrl: './edit-field.component.html',
  styleUrls: ['./edit-field.component.scss'],
})

export class EditFieldComponent implements OnInit {
  constructor(private formBuilder: FormBuilder,private constant: Constants,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,private loaderService: LoaderService,
    private toastr: ToastrService,private router: Router,private settingsService: SettingService,   
    private commonService: CommonService,private addFieldsVM: AddFieldsVM,private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.folderDetail = this.commonService.getEditData();
    if (this.folderDetail != undefined) {
      this.folderId = this.folderDetail.folderID;
    }
    this.fieldType = this.commonService.getFieldType();
    this.fieldEditData = this.commonService.getFieldData();
    if (this.fieldEditData != undefined || this.fieldEditData != null) {
      this.fieldData = this.fieldEditData.fieldData;
      this.isRequired = this.fieldData.isRequired;
      this.fieldFolderType = this.fieldEditData.fieldFolderType;
    } 

    if (this.fieldData != undefined) {
      this.typeSelected = this.fieldData.fieldTypeID;
      this.fieldLabel = this.fieldData.fieldName;
    }
  }
  selectedRoleList: any=[];
  selectedGlobalPermission = '0';
  givePermission:boolean = false;
  roleList: any=[];
  roleListFiltered:any=[];
  fieldType: any;
  fieldData: any;
  isRequired: boolean;
  EditField: boolean = false;
  fieldEditData: any;
  fieldFolderType: any;
  addFieldResponseHolder: any;
  folderDetail: any;
  @Output() closeSlide = new EventEmitter<boolean>();
  @Output() closeEditSlide = new EventEmitter<boolean>();
  folderId: any;
  closeSlideValue: boolean = false;
  closeEditPopup: boolean = false;
  currentUser: any;
  getFieldTypeListResponseHolder: any;
  fieldTypeList: any[] = [];
  fieldTypeReqModel = {
    userID: '',
    databaseID: 0,
    pageIndex: 1,
    pageSize: 10,
    officeID:0,
    OfficeIDList:[]
  };

  dropDownPlace: string = '';

  updateModel = {
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    fieldTypeName: '',
    folderID: 0,
    folderName: '',
    position: 0,
    defaultValue: '',
    isRequired: false,
    isDeactivated: false,
    fieldFolderType: 0,
    placeholder: '',
    fieldID: 0,
    officeID:0,
    OfficeIDList:[]
  };
  updateFieldResponseHolder: any;
  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: '',
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  imageTypeFieldArray: Array<any> = [];
  imageTypeFieldAttribute: any = {
    altText: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  urlTypeFieldArray: Array<any> = [];
  urlTypeFieldAttribute: any = {
    url: '',
  };

  numberTypeFieldArray: Array<any> = [];
  numberTypeFieldAttribute: any = {
    number: '',
  };

  dateTypeFieldArray: Array<any> = [];
  dateTypeFieldAttribute: any = {
    dateKey: '',
  };

  radioFieldArray: Array<any> = [];
  radioFieldAttribute: any = {
    radioText: '',
  };

  showRadioField: boolean = false;
  showDateField: boolean = false;
  showCurrencyField: boolean = false;
  showNumberField: boolean = false;
  showTextBoxField: boolean = false;
  showImageField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  showUrlField: boolean = false;
  selectedItems: any;
  typeSelected: any;
  dropdownFieldOptionArray: any[] = [];
  dropdownFieldOptionAttribute = {
    dropdownId: 0,
    dropdownOptionName: '',
  };
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    SearchKey:"",
    databaseID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };

  fieldLabel: any;
  position: any;
  isActive: boolean = false;
  roleCtrlFormControl = new FormControl();
  OfficeIDList: any = [];
  myOfficeID: any;
  
  ngOnInit(): void {
    this.updateCustomfieldForm = this.formBuilder.group({
      fieldCategoty: ['', Validators.required],
      fieldTypeID: ['', Validators.required],
      fieldName: ['', Validators.required],
      checkArray: this.formBuilder.array([], []),
      urlPlaceholder: [''],
      textboxPlaceholder: [''],
      numberPlaceholder: [''],
      currencyPlaceholder: [''],
      datePlaceholder: [''],
      dropPlaceholder: [''],
      availableonForms: ['', Validators.required]
    });

    
    this.getAllFolder();
    this.getFielddetils();

    this.getFieldTypeDropdown();
    this.getAllFields();
    this.getRoleList();
  }

  closeEdit(message: boolean) {
    this.closeEditSlide.emit(message);
  }

  valuechange(searchValue: string){
    this.updateCustomfieldForm.markAsDirty();
  }

  deleteField(value,removeIndex) {
    this.updateCustomfieldForm.markAsDirty();
    if (value == 'c') {      
     // let arrayLength = this.checkBoxFieldArray.length;
     // this.checkBoxFieldArray.splice(arrayLength - 1, 1);
     if (removeIndex !== -1) this.checkBoxFieldArray.splice(removeIndex, 1); 
    } else if (value == 'd') {
      //let arrayLength = this.dropdownFieldArray.length;
      //this.dropdownFieldArray.splice(arrayLength - 1, 1);
      if (removeIndex !== -1) this.dropdownFieldArray.splice(removeIndex, 1); 
    }    
  }

  searchRole(val:any){
    if(val!==undefined && val!=="") {
      this.roleListFiltered=this.roleList.filter(m=>m.roleName.toLowerCase().includes(val.toLowerCase()));
      this.roleListFiltered=this.roleListFiltered.filter(m=> !this.selectedRoleList.filter(m=>m.isDeleted==false).map(a => a.roleID).includes(m.roleID));
    }
    else{
      this.roleListFiltered=[];
    }
  }

  roleSelected(obj:any){
    this.roleListFiltered=[];
    this.roleCtrlFormControl.setValue("");
    if(this.selectedRoleList.filter(m=>m.isDeleted==false).map(a => a.roleID).includes(obj.roleID)){
      return ;
    }else{
         this.updateCustomfieldForm.markAsDirty();	
         this.selectedRoleList.push({isDeleted:false,fieldPermissionID:0,name:obj.roleName,roleID:obj.roleID,permission:0,action:1});
       }
  }

  globalPermission(event){
   this.selectedGlobalPermission=event.value;
   this.updateCustomfieldForm.markAsDirty();
  }

  changePermission(sr:any, permission:any) { 
    this.updateCustomfieldForm.markAsDirty();   
    this.selectedRoleList.find(m=>m.roleID==sr.roleID && m.isDeleted==false).permission=permission;
    if(sr.fieldPermissionID>0)
    this.selectedRoleList.find(m=>m.roleID==sr.roleID && m.isDeleted==false).action=2;
    else
    this.selectedRoleList.find(m=>m.roleID==sr.roleID && m.isDeleted==false).action=1;
  }
  
  deletePermission(sr:any){ 
    this.updateCustomfieldForm.markAsDirty();
    if(sr.fieldPermissionID>0){
    this.selectedRoleList.find(m=>m.roleID==sr.roleID && m.isDeleted==false).action=3;
    this.selectedRoleList.find(m=>m.roleID==sr.roleID && m.isDeleted==false).isDeleted=true;
    }else{
      let toBeDelete= this.selectedRoleList.filter(m=>m.roleID==sr.roleID);
      let toBeKept= this.selectedRoleList.filter(m=>m.roleID!==sr.roleID);
      toBeKept.push(toBeDelete.find(m=>m.roleID==sr.roleID && m.fieldPermissionID>0));
      this.selectedRoleList=  toBeKept;
    }
  }

  

  async getRoleList() {
    this.loaderService.show();    
    this.pageModelData.pageIndex = 0;
    this.pageModelData.pageSize = 0;
    this.pageModelData.databaseID =  Number(sessionStorage.getItem('databaseId'));
    this.pageModelData.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.pageModelData.officeID = this.myOfficeID;
    this.pageModelData.OfficeIDList = this.OfficeIDList;
    const result = await this.settingsService.getRoleList(this.pageModelData).toPromise();
    if (result.status === this.statusConst.statusSuccess) {  
      this.roleList = result.data.roleModel;
      this.loaderService.hide();  
    }
  }

  addpermission(){
    this.givePermission = !this.givePermission
  }

  getFielddetils() { 
    this.getFieldModelDetails.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getFieldModelDetails.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.getFieldModelDetails.userID = this.currentUser.UID;
    this.getFieldModelDetails.folderID = this.folderId;
    this.getFieldModelDetails.fieldID = this.fieldData.fieldID;
    this.getFieldModelDetails.officeID = this.myOfficeID;
    this.getFieldModelDetails.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.settingsService.getCustomdetails(this.getFieldModelDetails).subscribe((response) => {
        if (response != undefined) {
          this.getFieldsListResponseHolder = response;
          if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.updateFieldmodel.availableonForms= this.getFieldsListResponseHolder.data.availableOnForms;//1;//this.fieldEditData.fieldData.availableOn;
            this.fieldDetailsList = this.getFieldsListResponseHolder.data;
            this.folderIdCheck = true;
            if(this.getFieldsListResponseHolder.data.persmission)
            this.selectedGlobalPermission= String(this.getFieldsListResponseHolder.data.persmission);
            if(this.getFieldsListResponseHolder.data.rolePermissions){
              this.getFieldsListResponseHolder.data.rolePermissions.forEach(e => {
                this.selectedRoleList.push({isDeleted:false,name:e.roleName,roleID:e.roleID,permission:e.permission,fieldPermissionID:e.fieldPermissionID,action:0});
              });
            }
            this.updateFieldmodel.fieldCategotyTypeID = String(this.fieldDetailsList.fieldCategoryID);
            this.updateFieldmodel.fieldName = this.fieldDetailsList.fieldName;
            this.updateFieldmodel.fieldTypeID = this.fieldDetailsList.fieldTypeID;
            if (this.updateFieldmodel.fieldCategotyTypeID == '1' ) {
              const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
              var availableOn = this.fieldDetailsList.availableOn.filter((e) => e.folderName != 'Forms');

              availableOn.forEach((element) => {
                if (element.isChecked == true) {
                  this.folderIdCheckbox.push(element.folderID);
                  checkArray.push(new FormControl(element.folderID));
                }
              });
            }
            else if (this.updateFieldmodel.fieldCategotyTypeID == '2' ) {
              this.showFieldVategoryTypeGlobal = true;
              this.showFieldVategoryTypecustom = false;
              this.glbalDisable = false;
              this.customDisable = true;
              const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
              // && e.folderName!='Task'
              var availableOn = this.fieldDetailsList.availableOn.filter((e) => e.folderName != 'Forms');

              availableOn.forEach((element) => {
                if (element.isChecked == true) {
                  this.folderIdCheckbox.push(element.folderID);
                  checkArray.push(new FormControl(element.folderID));
                }
              });
            } 
            else if(this.updateFieldmodel.fieldCategotyTypeID == '3' ) {
              this.showFieldVategoryTypecustom = true;
              this.showFieldVategoryTypeGlobal = false;
              this.glbalDisable = true;
              this.customDisable = false;
              this.fieldDetailsList.availableOn.forEach((element) => {
                if (element.subFolders.length > 0) {
                  if (element.folderName == CCCName.Company) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.companyvaluesDropdown.push(e.subFolderID);
                      }
                    });
                  } else if (element.folderName == CCCName.Contact) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.contactvaluesDropdown.push(e.subFolderID);
                      }
                    });
                  } else if (element.folderName == CCCName.Core) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.corevaluesDropdown.push(e.subFolderID);
                      }
                    });
                  } else if (element.folderName == CCCName.Task) {
                    element.subFolders.forEach((e) => {
                      if (e.isChecked == true) {
                        this.taskvaluesDropdown.push(e.subFolderID);
                      }
                    });
                  }
                }
              });
            }
            this.fieldData = this.fieldDetailsList;
            this.bindDataForEdit(this.fieldData);
          } else {
            this.loaderService.hide();           
          }
        }
        this.loaderService.hide();
      });
  }

  getFieldTypeDropdown() {
    this.fieldTypeReqModel.userID = this.currentUser.UID;
    this.fieldTypeReqModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.fieldTypeReqModel.pageSize = 50;    
 	  this.fieldTypeReqModel.officeID = this.myOfficeID;
    this.fieldTypeReqModel.OfficeIDList = this.OfficeIDList;
    this.settingsService.getFieldTypeList(this.fieldTypeReqModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldTypeListResponseHolder = response;
          if(this.getFieldTypeListResponseHolder.status == this.statusConst.statusSuccess) {
            this.fieldTypeList = this.getFieldTypeListResponseHolder.data;
            this.fieldTypeList = this.fieldTypeList.filter((e) => e.fieldTypeName != 'Image');           
          } else {            
          }
        }
      });
  }

  addValueField() {
    let tempObject = Object.assign({}, this.checkBoxFieldAttribute);
    this.checkBoxFieldArray.push(tempObject);
    this.updateCustomfieldForm.markAsDirty();
  }

  displayFieldOnFieldTypeSelection(event) {
    if (event != undefined) {
      let fieldTypeName = '';
      this.fieldTypeList.forEach((element) => {
        if (element.fieldTypeID == event.value) {
          if(
            element.fieldTypeName == this.constant.TextArea ||
            element.fieldTypeName == this.constant.TextBox ) {
            this.updateCustomfieldForm.get('textboxPlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showTextBoxField = true;
            this.showDropdownBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.inputTypeFieldArray = [];
            this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
            this.checkBoxFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (
            element.fieldTypeName == this.constant.DropDownField ||
            element.fieldTypeName == this.constant.MultiSelect) {
            this.updateCustomfieldForm.get('dropPlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.showDropdownBoxField = true;
            this.showTextBoxField = false;
            this.showCheckboxField = false;
            this.showImageField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showUrlField = false;
            this.dropDownPlace = '';
            this.dropdownFieldArray = [];
            this.dropdownFieldArray.push(this.dropdownFieldAttribute);
            this.inputTypeFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.CheckboxField) {
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = true;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.checkBoxFieldArray = [];
            this.checkBoxFieldArray.push(this.checkBoxFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.imageTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.Image) {
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = true;
            this.showCurrencyField = false;
            this.showNumberField = false;
            this.showRadioField = false;
            this.showUrlField = false;
            this.showDateField = false;
            this.imageTypeFieldArray = [];
            this.imageTypeFieldArray.push(this.imageTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.urlTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.URL) {
            this.updateCustomfieldForm.get('urlPlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showNumberField = false;
            this.showDateField = false;
            this.urlTypeFieldArray = [];
            this.urlTypeFieldArray.push(this.urlTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.Number || element.fieldTypeName ==this.constant.Address) {
            this.updateCustomfieldForm.get('numberPlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = true;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.Currency) {
            this.updateCustomfieldForm.get('currencyPlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = true;
            this.showRadioField = false;
            this.showDateField = false;
            this.numberTypeFieldArray = [];
            this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
          } else if (element.fieldTypeName == this.constant.Date) {
            this.updateCustomfieldForm.get('datePlaceholder').setValidators(Validators.required);
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showRadioField = false;
            this.showDateField = true;
            this.dateTypeFieldArray = [];
            this.dateTypeFieldArray.push(this.dateTypeFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.radioFieldArray = [];
          } else {
            this.showCheckboxField = false;
            this.showDropdownBoxField = false;
            this.showTextBoxField = false;
            this.showImageField = false;
            this.showUrlField = false;
            this.showNumberField = false;
            this.showCurrencyField = false;
            this.showDateField = false;
            this.showRadioField = false;
            this.radioFieldArray.push(this.radioFieldAttribute);
            this.inputTypeFieldArray = [];
            this.dropdownFieldArray = [];
            this.checkBoxFieldArray = [];
            this.imageTypeFieldArray = [];
            this.numberTypeFieldArray = [];
            this.urlTypeFieldArray = [];
            this.dateTypeFieldArray = [];
            this.updateCustomfieldForm.get('dropPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('numberPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('currencyPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('datePlaceholder').clearValidators();
            this.updateCustomfieldForm.get('textboxPlaceholder').clearValidators();
            this.updateCustomfieldForm.get('urlPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('numberPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('currencyPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('datePlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('textboxPlaceholder').updateValueAndValidity();
            this.updateCustomfieldForm.get('dropPlaceholder').updateValueAndValidity();
          }
        }
      });
    }
  }

  bindDataForEdit(editData) {
    if(this.fieldData.fieldTypeName == this.constant.TextArea || this.fieldData.fieldTypeName == this.constant.TextBox) {
      this.showTextBoxField = true;
      this.showDropdownBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      this.inputTypeFieldArray = [];
      this.inputTypeFieldAttribute.fieldText = this.fieldData.defaultValue;
      this.inputTypeFieldAttribute.placeholder = this.fieldData.placeholder;
      this.inputTypeFieldArray.push(this.inputTypeFieldAttribute);
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.imageTypeFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('textboxPlaceholder').setValidators(Validators.required);
    } else if (
      this.fieldData.fieldTypeName == this.constant.DropDownField ||
      this.fieldData.fieldTypeName == this.constant.MultiSelect) {
      this.showDropdownBoxField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      var dropdownValue = this.fieldData.defaultValue.replace(/,\s*$/, '');
      var Valuearray=[];
      Valuearray = dropdownValue.split(',');
      if(Valuearray.length>0){
        Valuearray = Valuearray.filter(el => Object.keys(el).length);
        if(Valuearray.length>0){
          Valuearray.forEach((element) => {
            let copyModel = Object.assign({}, this.dropdownFieldAttribute);
            copyModel.dropdownText = element;
            this.dropdownFieldArray.push(copyModel);
          });
        }       
      }      
      this.dropDownPlace = this.fieldData.placeholder;
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.imageTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('dropPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.RadioButton) {
      this.showDropdownBoxField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      let Valuearray = this.fieldData.defaultValue.split(',');
      Valuearray.forEach((element) => {
        let copyModel = Object.assign({}, this.radioFieldAttribute);
        copyModel.radioText = element;
        this.radioFieldArray.push(copyModel);
      });
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.imageTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
    } else if (this.fieldData.fieldTypeName == this.constant.Image) {
      this.showDropdownBoxField = false;
      this.showImageField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showNumberField = false;
      this.showUrlField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      this.imageTypeFieldAttribute.altText = this.fieldData.defaultValue;
      this.imageTypeFieldArray.push(this.imageTypeFieldAttribute);
      this.urlTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
    } else if (this.fieldData.fieldTypeName == this.constant.URL) {
      this.showDropdownBoxField = false;
      this.showUrlField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showImageField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      this.urlTypeFieldAttribute.url = this.fieldData.placeholder;
      this.urlTypeFieldArray.push(this.urlTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('urlPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Number || this.fieldData.fieldTypeName == this.constant.Address ) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = true;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      this.numberTypeFieldAttribute.number = this.fieldData.placeholder;
      this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('numberPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Currency) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = true;
      this.showDateField = false;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      this.numberTypeFieldAttribute.number = this.fieldData.placeholder;
      this.numberTypeFieldArray.push(this.numberTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('currencyPlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.Date) {
      this.showDropdownBoxField = false;
      this.showImageField = false;
      this.showUrlField = false;
      this.showNumberField = false;
      this.showTextBoxField = false;
      this.showCheckboxField = false;
      this.showCurrencyField = false;
      this.showDateField = true;
      this.showRadioField = false;
      // this.dropdownFieldArray.push(this.dropdownFieldAttribute);
      this.dateTypeFieldAttribute.dateKey = this.fieldData.placeholder;
      this.dateTypeFieldArray.push(this.dateTypeFieldAttribute);
      this.imageTypeFieldArray = [];
      this.inputTypeFieldArray = [];
      this.checkBoxFieldArray = [];
      this.dropdownFieldArray = [];
      this.urlTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
      this.updateCustomfieldForm.get('datePlaceholder').setValidators(Validators.required);
    } else if (this.fieldData.fieldTypeName == this.constant.CheckboxField) {
      this.showCheckboxField = true;
      this.showDropdownBoxField = false;
      this.showTextBoxField = false;
      this.showUrlField = false;
      this.showImageField = false;
      this.showNumberField = false;
      this.showCurrencyField = false;
      this.showDateField = false;
      this.showRadioField = false;      
     
      var checkboxValue = this.fieldData.defaultValue.replace(/,\s*$/, '');
      var Valuearray=[];
      Valuearray = checkboxValue.split(',');
      if(Valuearray.length>0){
        Valuearray = Valuearray.filter(el => Object.keys(el).length);
        if(Valuearray.length>0){
          Valuearray.forEach((element) => {
            let copyModel = Object.assign({}, this.checkBoxFieldAttribute);
            copyModel.Select = element;
            this.checkBoxFieldArray.push(copyModel);
          });
        }       
      }  
      this.inputTypeFieldArray = [];
      this.dropdownFieldArray = [];
      this.imageTypeFieldArray = [];
      this.urlTypeFieldArray = [];
      this.dateTypeFieldArray = [];
      this.numberTypeFieldArray = [];
      this.radioFieldArray = [];
    } else {
    }
  }

  addValueFieldRadio() {
    let tempObject = Object.assign({}, this.radioFieldAttribute);
    this.radioFieldArray.push(tempObject);
    this.updateCustomfieldForm.markAsDirty();
  }

  addValueFieldropdown() {
    this.dropdownFieldAttribute = null;
    let tempObject = Object.assign({}, this.dropdownFieldAttribute);
    this.dropdownFieldArray.push(tempObject);
    this.updateCustomfieldForm.markAsDirty();
  }

  spinner:boolean=false;

  updateField(formValues) {
    this.spinner=true;
    this.updateCustomfieldForm.markAsPristine();
    this.updateCustomField.fieldID = this.fieldData.fieldID;
    this.updateCustomField.userID = this.currentUser.UID;
    this.updateCustomField.folderID = this.folderDetail.folderID;
    this.updateCustomField.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.updateCustomField.fieldName = this.updateFieldmodel.fieldName;
    this.updateCustomField.fieldTypeID = this.updateFieldmodel.fieldTypeID;
    this.updateCustomField.fieldCategotyTypeID = parseInt(this.updateFieldmodel.fieldCategotyTypeID);
    this.updateCustomField.organizationID = Number(sessionStorage.getItem('organizationID'));    
	  this.updateCustomField.officeID = this.myOfficeID;
    this.updateCustomField.OfficeIDList = this.OfficeIDList;
    this.updateCustomField.permission=Number(this.selectedGlobalPermission);
    this.selectedRoleList.forEach(e => {
        this.updateCustomField.rolePermissions.push({
          "roleID": e.roleID,
          "permission": e.permission,
          "fieldPermissionID": e.fieldPermissionID,
          "fieldID": this.fieldData.fieldID,
          "organizationID":Number(sessionStorage.getItem('organizationID')),
          "action": e.action 
          //Add=1,
         // Modified=2,
         // Remove=3
        })
      });
    this.updateCustomField.defaultValue = '';
    this.updateCustomField.AvailableOn =Number(formValues.availableonForms);
    if (this.showDropdownBoxField == true) {
      if( this.dropdownFieldArray.length>0){
        this.dropdownFieldArray = this.dropdownFieldArray.filter(el => Object.keys(el).length);       
        this.dropdownFieldArray.forEach((element) => {
          if(element.dropdownText!="" && element.dropdownText!=null){
            //this.updateCustomField.defaultValue += element.dropdownText + ',';
            this.updateCustomField.defaultValue +=  (element.dropdownText.toString().replace(/,/g, "")) + ',';             
            this.updateCustomField.placeholder = this.dropDownPlace;
          }       
      });

      this.updateCustomField.defaultValue =  this.updateCustomField.defaultValue.replace(/,\s*$/, "");
     }
    } else if (this.showCheckboxField == true) {
      if( this.checkBoxFieldArray.length>0){
        this.checkBoxFieldArray = this.checkBoxFieldArray.filter(el => Object.keys(el).length);
        this.checkBoxFieldArray.forEach((element) => {
          if(element.Select!="" && element.Select!=null){
            this.updateCustomField.defaultValue += element.Select + ',';           
          }       
      });     
     }
    } else if (this.showTextBoxField == true) {
      this.inputTypeFieldArray.forEach((element) => {
        this.updateCustomField.defaultValue += element.fieldText;
        this.updateCustomField.placeholder = element.placeholder;
      });
    } else if (this.showImageField == true) {
      this.imageTypeFieldArray.forEach((element) => {
        this.updateCustomField.defaultValue += element.altText;
        // this.updateModel.placeholder = element.placeholder;
      });
    } else if (this.showUrlField == true) {
      this.urlTypeFieldArray.forEach((element) => {
        this.updateCustomField.placeholder += element.url;
        // this.updateModel.placeholder = element.placeholder;
      });
    } else if (this.showNumberField == true || this.showCurrencyField) {
      this.numberTypeFieldArray.forEach((element) => {
        this.updateCustomField.placeholder += element.number;
        // this.updateModel.placeholder = element.placeholder;
      });
    } else if (this.showDateField == true) {
      this.dateTypeFieldArray.forEach((element) => {
        this.updateCustomField.placeholder += element.dateKey;
        // this.updateModel.placeholder = element.placeholder;
      });
    } else if (this.showRadioField == true) {
      this.radioFieldArray.forEach((element) => {
        this.updateCustomField.defaultValue += element.radioText + ',';
        // this.updateModel.placeholder = element.placeholder;
      });
    } else {
    }
    let tempArray = [];
    if (this.updateCustomField.fieldCategotyTypeID == 3) {
      if (this.corevaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == CCCName.Core) {
            for (let i of this.corevaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }

      if (this.contactvaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == 'Contact') {
            for (let i of this.contactvaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }

      if (this.taskvaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == 'Task') {
            for (let i of this.taskvaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }

      if (this.companyvaluesDropdown.length > 0) {
        this.fieldDetailsList.availableOn.forEach((element) => {
          if (element.folderName == CCCName.Company) {
            for (let i of this.companyvaluesDropdown) {
              let copyModel = Object.assign({}, this.selectedFolders);
              copyModel.folderID = element.folderID;
              copyModel.subFolderID = i;
              tempArray.push(copyModel);
            }
          }
        });
      }
      this.updateCustomField.selectedFolders = tempArray;
    } else {
      formValues.checkArray.forEach((element) => {
        let copyModel = Object.assign({}, this.selectedFolders);
        copyModel.folderID = element;
        tempArray.push(copyModel);
      });
      this.updateCustomField.selectedFolders = tempArray;
    }    
    this.settingsService.updateField(this.updateCustomField).subscribe((response) => {
        if (response != undefined) {
          this.spinner=false;
          this.updateFieldResponseHolder = response;
          this.inputTypeFieldArray = [];
          this.checkBoxFieldArray = [];
          this.dropdownFieldArray = [];
          if (this.updateFieldResponseHolder.status ==  this.statusConst.statusSuccess ) {
            this.toastr.success('Field updated successfully.', '', {
              timeOut: 3000,
            });
            this.closeEdit(false);
            if ((this.customDisable = true)) {
              this._dataSharingService.sendClickEventforCustomFields();
            }
          } else {
            this.spinner=false;
            this.loaderService.hide();  
            this.closeEdit(false);         
          }
        }else {
          this.spinner=false;
          this.loaderService.hide();   
          this.closeEdit(false);        
        }
      });
  }

  //********************************************** */

  updateCustomfieldForm: FormGroup;

  getAllfolderList = {
    folderID: 0,
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[]
  };

  getAllSubfolderListResponseHolder: any;

  selectedFolders = {
    folderID: 0,
    subFolderID: 0,
  };

  showFieldVategoryTypeGlobal: boolean = true;
  showFieldVategoryTypecustom: boolean = false;
  coreList: any;
  taskList: any;
  companyList: any;
  contactList: any;
  coreValue: any[] = [];
  taskValue: any[] = [];
  companyValue: any[] = [];
  contactValue: any[] = [];
  dropdownValue: any[] = [];
  fieldDetailsList: any;

  updateCustomField = {
    permission:0,
    rolePermissions:[],
    fieldID: 0,
    folderID:0,
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    placeholder: '',
    defaultValue: '',
    fieldCategotyTypeID: 0,
    organizationID: 0,
    officeID:0,
    OfficeIDList:[],
    AvailableOn:1,
    selectedFolders: [
      {
        folderID: 0,
        subFolderID: 0,
      },
    ],
  };

  defaultDisable:boolean=false;
  glbalDisable: boolean = false;
  customDisable: boolean = false;

  updateFieldmodel = {
    userID: '',
    databaseID: 0,
    fieldName: '',
    fieldTypeID: 0,
    position: 0,
    defaultValue: '',
    fieldCategotyTypeID: '',
    organizationID: 0,
    AvailableOn:1,
    fieldNames: null,
    availableonForms:0
  };

  folderIdCheckbox: any[] = [];
  corevaluesDropdown: any[] = [];
  taskvaluesDropdown: any[] = [];
  companyvaluesDropdown: any[] = [];
  contactvaluesDropdown: any[] = [];

  getFieldModelDetails = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
    folderID: 0,
    fieldID: 0,
    officeID:0,
    OfficeIDList:[]
  };

  folderIdCheck: boolean = false;
  getFieldsListResponseHolder: any;
  getFieldModel = {
    userID: '',
    databaseID: 0,
    organizationID:0,
    officeID:0,
    OfficeIDList:[]
  };
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  fieldLists: any[] = [];

  checkArray:FormArray;

  onCheckboxChange(e) { 
    this.updateCustomfieldForm.markAsDirty();
    this.checkArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
    if (e.checked) {
      let a = e.source.value;
      this.checkArray .push(new FormControl(e.source.value));
    } else {
      let i: number = 0;
      this.checkArray .controls.forEach((item: FormControl) => {
        if (item.value == e.source.value) {
          this.checkArray .removeAt(i);
          return;
        }
        i++;
      });
    }

    if (this.checkArray .length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }
  }

  onRadiobuttonChange(e) {
    if (e.source.value == '2' || e.source.value == '1') {
      this.showFieldVategoryTypeGlobal = true;
      this.showFieldVategoryTypecustom = false;
    } else {
      this.showFieldVategoryTypecustom = true;
      this.showFieldVategoryTypeGlobal = false;
    }
    this.corevaluesDropdown = [];
    this.taskvaluesDropdown = [];
    this.companyvaluesDropdown = [];
    this.contactvaluesDropdown = [];
    this.folderIdCheckbox = [];
    this.updateCustomfieldForm.controls['fieldTypeID'].setValue('');
    this.clear();
  }  

  getAllFolder() {
    this.getAllfolderList.userID = this.currentUser.UID;
    this.getAllfolderList.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getAllfolderList.folderID = 0;
    this.getAllfolderList.officeID = this.myOfficeID;
    this.getAllfolderList.OfficeIDList = this.OfficeIDList;
    this.getAllfolderList.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.settingsService.getAllFolderlist(this.getAllfolderList).subscribe((response) => {
        if (response != undefined) {
          this.getAllSubfolderListResponseHolder = response;
          if (this.getAllSubfolderListResponseHolder.status ==  this.statusConst.statusSuccess) {
            this.getAllSubfolderListResponseHolder.data.forEach((element) => {
              if (element.folderName == CCCName.Company) {
                this.companyList = element.subFolders;
              } else if (element.folderName == CCCName.Contact) {
                this.contactList = element.subFolders;
              } else if (element.folderName == CCCName.Core) {
                this.coreList = element.subFolders;
              } else if (element.folderName == CCCName.Task) {
                this.taskList = element.subFolders;
              }
            });
          } else {
            this.loaderService.hide();            
          }
        }
      });
  }

  displayavailableonSelection(e) {
    this.updateCustomfieldForm.markAsDirty();
    if (this.checkArray.length != 0) {
      this.folderIdCheck = true;
    } else {
      this.folderIdCheck = false;
    }    
  }

  displayCoreTypeSelection(e) {
    this.updateCustomfieldForm.markAsDirty();
    this.coreValue = e.value;
    if(this.corevaluesDropdown.length == 0 && this.contactvaluesDropdown.length == 0 && this.companyvaluesDropdown.length == 0) {
      //this.folderIdCheck = true;
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }

    // if (
    //   this.taskvaluesDropdown.length == 0 &&
    //   this.corevaluesDropdown.length == 0 &&
    //   this.contactvaluesDropdown.length == 0 &&
    //   this.companyvaluesDropdown.length == 0) {
    //   this.folderIdCheck = true;
    //   //this.folderIdCheck = false;
    // } else {
    //   this.folderIdCheck = true;
    // }
  }

  displayTaskTypeSelection(e) {
    this.updateCustomfieldForm.markAsDirty();
    this.taskValue = e.value;
    if (
      this.taskvaluesDropdown.length == 0 &&
      this.corevaluesDropdown.length == 0 &&
      this.contactvaluesDropdown.length == 0 &&
      this.companyvaluesDropdown.length == 0) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayCompanyTypeSelection(e) {
    this.updateCustomfieldForm.markAsDirty();
    this.companyValue = e.value;
    if (
      this.taskvaluesDropdown.length == 0 &&
      this.corevaluesDropdown.length == 0 &&
      this.contactvaluesDropdown.length == 0 &&
      this.companyvaluesDropdown.length == 0) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  displayContactTypeSelection(e) { 
    this.updateCustomfieldForm.markAsDirty();
    this.contactValue = e.value;
    if (
      this.taskvaluesDropdown.length == 0 &&
      this.corevaluesDropdown.length == 0 &&
      this.contactvaluesDropdown.length == 0 &&
      this.companyvaluesDropdown.length == 0) {
      this.folderIdCheck = false;
    } else {
      this.folderIdCheck = true;
    }
  }

  clear() {
    const checkArray: FormArray = this.updateCustomfieldForm.get('checkArray') as FormArray;
    checkArray.clear();
    this.showCheckboxField = false;
    this.showDropdownBoxField = false;
    this.showTextBoxField = false;
    this.showImageField = false;
    this.showUrlField = false;
    this.showNumberField = false;
    this.showCurrencyField = false;
    this.showRadioField = false;
    this.showDateField = false;
    this.inputTypeFieldArray = [];
    this.checkBoxFieldArray = [];
    this.dropdownFieldArray = [];
    this.imageTypeFieldArray = [];
    this.urlTypeFieldArray = [];
    this.numberTypeFieldArray = [];
    this.dateTypeFieldArray = [];
    this.radioFieldArray = [];
    this.getAllFolder();
    this.getAllFields();
    this.taskValue = [];
    this.coreValue = [];
    this.contactValue = [];
    this.companyValue = [];
  }

  CompanyName:string="";
  CoreName:string="";
  ContactName:string="";

  getAllFields() {
    this.getFieldModel.userID = this.currentUser.UID;
    this.getFieldModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getFieldModel.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.getFieldModel.officeID = this.myOfficeID;   
    this.getFieldModel.OfficeIDList = this.OfficeIDList;    
    this.settingsService.getAllFolderlist(this.getFieldModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldsListResponseHolder = response;
          if (this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess ) {
            // m.folderName != "Task" &&
            this.fieldsList = this.getFieldsListResponseHolder.data.filter((m) => m.folderName != "Forms");
          
            var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
            var coreName=[];
            coreName = menuModulesList.filter(x => x.mainModuleName == CCCName.Core); 
            if(coreName.length>0){
              this.CoreName= coreName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Core).folderName = this.CoreName;
            }
          
            var contName =[];
            contName = menuModulesList.filter(x => x.mainModuleName == CCCName.Contact);
            if(contName.length>0){
              this.ContactName = contName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Contact).folderName = this.ContactName;
            }
           
            var compName =[];
            compName = menuModulesList.filter(x => x.mainModuleName == CCCName.Company);
            if(compName.length>0){
              this.CompanyName = compName[0].orgModuleName;
              this.fieldsList.find((item) => item.folderName == CCCName.Company).folderName = this.CompanyName;
            }               
                                 
            this.fieldsList.forEach((element) => {
              if (element.folderID == this.folderId) {
                this.fieldListFolderWise = element.fieldData;
              }
            });
          } else {
            this.loaderService.hide();
          }
        }
      });
  }
  

  
  addNewField(value) {
    this.folderDetail = this.commonService.getEditData();
    this.fieldType = this.commonService.getFieldType();
    if (this.folderDetail != undefined) {
      this.folderId = this.folderDetail.folderID;
    }
    this.addFieldsVM.defaultValue = '';
    this.addFieldsVM.userID = this.currentUser.UID;
    this.addFieldsVM.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.addFieldsVM.organizationID = Number(sessionStorage.getItem('organizationID'));
    this.addFieldsVM.officeID = this.myOfficeID;
    this.addFieldsVM.OfficeIDList = this.OfficeIDList;
    this.addFieldsVM.folderName = this.folderDetail.folderName;
    this.addFieldsVM.fieldTypeID = this.typeSelected;
    if (this.fieldType.subfolderId > 0) {
      this.addFieldsVM.fieldFolderType = this.fieldType.fieldType;
      this.addFieldsVM.folderID = this.fieldType.subfolderId;
    } else {
      this.addFieldsVM.fieldFolderType = 1;
      this.addFieldsVM.folderID = this.folderId;
    }
    let count = this.fieldListFolderWise.length;
    this.addFieldsVM.position = count + 1;
    this.fieldTypeList.forEach((element) => {
      if (element.fieldTypeID == this.typeSelected) {
        this.addFieldsVM.fieldTypeName = element.fieldTypeName;
      }
    });
    if (this.showDropdownBoxField == true) {
        this.dropdownFieldArray.forEach((element) => {
       // this.addFieldsVM.defaultValue += element.dropdownText + ',';
       this.addFieldsVM.defaultValue += (element.dropdownText.toString().replace(/,/g, "")) + ',';
      });
    } else if (this.showCheckboxField == true) {
      this.checkBoxFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.Select + ',';
      });
    } else if (this.showTextBoxField == true) {
      this.inputTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.fieldText;
        this.addFieldsVM.placeholder = element.placeholder;
      });
    } else if (this.showImageField == true) {
      this.imageTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.altText;
      });
    } else if (this.showUrlField == true) {
      this.urlTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.url;
      });
    } else if (this.showNumberField == true || this.showCurrencyField == true) {
      this.numberTypeFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.number;
      });
    } else if (this.showRadioField == true) {
      this.radioFieldArray.forEach((element) => {
        this.addFieldsVM.defaultValue += element.radioText + ',';
      });
    }
    this.addFieldsVM.fieldName = this.fieldLabel;
    let lastIndex = this.addFieldsVM.defaultValue.length;
    this.addFieldsVM.defaultValue = this.addFieldsVM.defaultValue.substr(0,lastIndex - 1);
    this.settingsService.addField(this.addFieldsVM).subscribe((response) => {
      if (response != undefined) {
        this.addFieldResponseHolder = response;
        this.inputTypeFieldArray = [];
        this.checkBoxFieldArray = [];
        this.dropdownFieldArray = [];
        if (this.addFieldResponseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Field added successfully.', '', {
            timeOut: 3000,
          });
          this.getAllFields();
        } else {          
          this.closeSlide.emit(false);
          this.loaderService.hide();
        }
      }
    });
  }

  drop(event: CdkDragDrop<any[]>) {
     moveItemInArray(this.dropdownFieldArray, event.previousIndex, event.currentIndex);
     this.updateCustomfieldForm.markAsDirty();
  }
}
